export const SET_HOME_BOOKMARK = 'SET_HOME_BOOKMARK';
export const SET_SELECTED_BOOKMARK = 'SET_SELECTED_BOOKMARK';

export const CREATE_BOOKMARK_SUCCESS = 'CREATE_BOOKMARK_SUCCESS';

export const TOGGLE_HOME_BOOKMARK_REQUEST = 'TOGGLE_HOME_BOOKMARK_REQUEST';
export const TOGGLE_HOME_BOOKMARK_FAILURE = 'TOGGLE_HOME_BOOKMARK_FAILURE';
export const TOGGLE_HOME_BOOKMARK_SUCCESS = 'TOGGLE_HOME_BOOKMARK_SUCCESS';

export const FETCH_HOME_BOOKMARK_REQUEST = 'FETCH_HOME_BOOKMARK_REQUEST';
export const FETCH_HOME_BOOKMARK_SUCCESS = 'FETCH_HOME_BOOKMARK_SUCCESS';
export const FETCH_HOME_BOOKMARK_FAILURE = 'FETCH_HOME_BOOKMARK_FAILURE';